import cuid from "cuid";
import { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { useMutation } from "shared/hooks/useApi";
import graphql from "utils/api/graphql";
import { PRODUCT_RANGES } from "utils/api/graphql/queries/product-range-advisor-codes";
import { INITIAL_VALUES, SCREENS } from "utils/constants";
import View from "./View";

const Create = () => {
  const navigate = useNavigate();
  const id = useMemo(() => cuid(), []);
  const cancel = () => navigate(SCREENS.PRIVATE.ADMIN.PRODUCT_RANGES.LIST.path);
  const [addProductRange] = useMutation(graphql.mutations.ADD_PRODUCT_RANGE, {
    apiErrorOptions: {
      duplicateKeyMessageKey: "PRODUCT_RANGE_DUPLICATE",
    },
    refetchQueries: [
      {
        query: PRODUCT_RANGES,
        awaitRefetchQueries: true,
        variables: {
          ...INITIAL_VALUES,
          orderBy: [{ code: "ASC" }],
        },
      },
    ],
    onCompleted: () => {
      navigate(SCREENS.PRIVATE.ADMIN.PRODUCT_RANGES.LIST.path);
    },
  });
  const onSubmit = (values) => {
    const labelTrimmed = (values.label || "").trim();
    return addProductRange({
      variables: {
        data: {
          id,
          code: values.code.trim(),
          ...(labelTrimmed ? { label: labelTrimmed } : {}),
        },
      },
    });
  };
  return <View onSubmit={onSubmit} cancel={cancel} />;
};

export default Create;
